import React, { useEffect, useState, useMemo } from "react";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter,
  Label, Input, Form, Badge, Spinner, Button, UncontrolledTooltip,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

const KullaniciListesi = () => {
  document.title = "Kullanıcı Listesi | LojGo Admin";

  const BASE_URL = "https://hiflowapi.stechomeyazilim.info";

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [activeViewTab, setActiveViewTab] = useState("1");
  const [activeEditTab, setActiveEditTab] = useState("1"); // Düzenleme Modalı Sekmeleri
  
  const [selectedUser, setSelectedUser] = useState(null); // Düzenleme için state
  const [detailedUser, setDetailedUser] = useState(null); // Görüntüleme için state
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [approveLoading, setApproveLoading] = useState(null); // onaylanan kullanıcının ID'si
  const [docApproveLoading, setDocApproveLoading] = useState(null); // belgesi onaylanan kullanıcının ID'si
  const [deleteModal, setDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  useEffect(() => {
    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/Users?$expand=Users_Type&$orderby=ID desc`);
      const result = await response.json();
      setUsers(result.value || []);
    } catch (error) {
      toast.error("Kullanıcılar yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- GÖRÜNTÜLEME MODALI AÇILIŞI ---
  const handleViewProfile = async (user) => {
    setViewModal(true);
    setIsDetailsLoading(true);
    setActiveViewTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/Users?$filter=ID eq ${user.ID}&$expand=Users_Address,Users_Driving_License,Users_BankAccount,Users_Document,Users_Company($expand=Users_Invoince)`
      );
      const result = await response.json();
      if (result.value && result.value.length > 0) setDetailedUser(result.value[0]);
    } catch (error) {
      toast.error("Profil detayları yüklenemedi.");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  // --- DÜZENLEME MODALI AÇILIŞI (TÜM VERİLERİ ÇEK) ---
  const handleEditProfile = async (user) => {
    setEditModal(true);
    setIsDetailsLoading(true);
    setActiveEditTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/Users?$filter=ID eq ${user.ID}&$expand=Users_Address,Users_Driving_License,Users_BankAccount,Users_Company($expand=Users_Invoince)`
      );
      const result = await response.json();
      const fullUser = result.value?.[0];

      if (fullUser) {
        // Tüm ilişkili tabloları düz (flat) bir state objesinde topluyoruz ki form elemanlarına kolay bağlansın
        setSelectedUser({
          ID: fullUser.ID,
          Users_NameSurname: fullUser.Users_NameSurname || "",
          Users_Email: fullUser.Users_Email || "",
          Users_PhoneNumber: fullUser.Users_PhoneNumber || "",
          IsActive: fullUser.IsActive,

          Address_ID: fullUser.Users_Address?.[0]?.ID,
          City: fullUser.Users_Address?.[0]?.Users_Address_City || "",
          District: fullUser.Users_Address?.[0]?.Users_Address_Dist || "",
          AddressText: fullUser.Users_Address?.[0]?.Users_Address_AdressText || "",

          License_ID: fullUser.Users_Driving_License?.[0]?.ID,
          License_Class: fullUser.Users_Driving_License?.[0]?.Driving_License_Class || "",
          License_No: fullUser.Users_Driving_License?.[0]?.Driving_License_Number || "",

          Company_ID: fullUser.Users_Company?.[0]?.ID,
          Company_Name: fullUser.Users_Company?.[0]?.Users_Company_Name || "",

          Invoice_ID: fullUser.Users_Company?.[0]?.Users_Invoince?.[0]?.ID,
          Tax_No: fullUser.Users_Company?.[0]?.Users_Invoince?.[0]?.KdvNumber || "",
          Tax_Office: fullUser.Users_Company?.[0]?.Users_Invoince?.[0]?.VergiDairesi || "",

          Bank_ID: fullUser.Users_BankAccount?.[0]?.ID,
          IBAN: fullUser.Users_BankAccount?.[0]?.Users_BankAccount_Iban || "",
          Bank_Name: fullUser.Users_BankAccount?.[0]?.Users_BankAccount_BankName || ""
        });
      }
    } catch (error) {
      toast.error("Düzenlenecek profil detayları yüklenemedi.");
      setEditModal(false);
    } finally {
      setIsDetailsLoading(false);
    }
  };

  // --- TÜM BİLGİLERİ GÜNCELLEME (ÇOKLU API İSTEĞİ) ---
  const handleEditSubmit = async () => {
    if (!selectedUser) return;
    setIsSaving(true);

    try {
      const uid = selectedUser.ID;

      // 1. ANA KULLANICI GÜNCELLEMESİ (PATCH)
      const userPromise = fetch(`${BASE_URL}/Users(${uid})`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Users_NameSurname: selectedUser.Users_NameSurname,
          Users_Email: selectedUser.Users_Email,
          Users_PhoneNumber: selectedUser.Users_PhoneNumber,
          IsActive: selectedUser.IsActive
        }),
      });

      // 2. ADRES GÜNCELLEMESİ / EKLENMESİ
      const addressPayload = { Users_ID: uid, Users_Address_City: selectedUser.City, Users_Address_Dist: selectedUser.District, Users_Address_AdressText: selectedUser.AddressText };
      const addressPromise = selectedUser.Address_ID 
        ? fetch(`${BASE_URL}/Users_Address(${selectedUser.Address_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(addressPayload) })
        : fetch(`${BASE_URL}/Users_Address`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(addressPayload) });

      // 3. EHLİYET GÜNCELLEMESİ / EKLENMESİ
      const licensePayload = { Users_ID: uid, Driving_License_Class: selectedUser.License_Class, Driving_License_Number: selectedUser.License_No };
      const licensePromise = selectedUser.License_ID
        ? fetch(`${BASE_URL}/Users_Driving_License(${selectedUser.License_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload) })
        : fetch(`${BASE_URL}/Users_Driving_License`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload) });

      // 4. BANKA GÜNCELLEMESİ / EKLENMESİ
      const bankPayload = { Users_ID: uid, Users_BankAccount_Iban: selectedUser.IBAN, Users_BankAccount_BankName: selectedUser.Bank_Name };
      const bankPromise = selectedUser.Bank_ID
        ? fetch(`${BASE_URL}/Users_BankAccount(${selectedUser.Bank_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(bankPayload) })
        : fetch(`${BASE_URL}/Users_BankAccount`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(bankPayload) });

      // 5. ŞİRKET VE VERGİ GÜNCELLEMESİ
      let companyPromise = Promise.resolve();
      let invoicePromise = Promise.resolve();
      
      if (selectedUser.Company_ID) {
        // Mevcut şirket varsa güncelle
        companyPromise = fetch(`${BASE_URL}/Users_Company(${selectedUser.Company_ID})`, {
          method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ Users_Company_Name: selectedUser.Company_Name })
        });
        // Faturası varsa güncelle, yoksa ekle
        const invPayload = { Users_Company_ID: selectedUser.Company_ID, KdvNumber: selectedUser.Tax_No, VergiDairesi: selectedUser.Tax_Office };
        if (selectedUser.Invoice_ID) {
           invoicePromise = fetch(`${BASE_URL}/Users_Invoince(${selectedUser.Invoice_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(invPayload) });
        } else {
           invoicePromise = fetch(`${BASE_URL}/Users_Invoince`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(invPayload) });
        }
      } else if (selectedUser.Company_Name) {
        // Şirket yok ama isim girilmişse önce Şirketi POST yap
        const newCompRes = await fetch(`${BASE_URL}/Users_Company`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ Users_ID: uid, Users_Company_Name: selectedUser.Company_Name }) });
        const newComp = await newCompRes.json();
        // Sonra da Invoince POST yap
        const invPayload = { Users_Company_ID: newComp.ID, KdvNumber: selectedUser.Tax_No, VergiDairesi: selectedUser.Tax_Office };
        invoicePromise = fetch(`${BASE_URL}/Users_Invoince`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(invPayload) });
      }

      // Tüm istekleri paralel yolla
      await Promise.all([userPromise, addressPromise, licensePromise, bankPromise, companyPromise, invoicePromise]);

      toast.success("Kullanıcının tüm bilgileri başarıyla güncellendi.");
      setEditModal(false);
      fetchUsers(); // Tabloyu yenile

    } catch (error) {
      console.error("Güncelleme Hatası:", error);
      toast.error("Güncelleme sırasında bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (field, value) => {
    setSelectedUser(prev => ({ ...prev, [field]: value }));
  };

  // --- SÜRÜCÜ BAŞVURUSUNU ONAYLA (tip değişikliği + belge onayı) ---
  const handleApproveDriver = async (user) => {
    setApproveLoading(user.ID);
    try {
      await fetch(`${BASE_URL}/Users(${user.ID})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Users_Type_ID: 2, IsDocument: 1, IsDocumentApproved: true }),
      });
      toast.success(`${user.Users_NameSurname} sürücü olarak onaylandı.`);
      fetchUsers();
    } catch (error) {
      toast.error("Onaylama sırasında bir hata oluştu.");
    } finally {
      setApproveLoading(null);
    }
  };

  // --- YÜKLENEN BELGELERİ ONAYLA (sadece IsDocumentApproved) ---
  const handleApproveDocuments = async (user) => {
    setDocApproveLoading(user.ID);
    try {
      await fetch(`${BASE_URL}/Users(${user.ID})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ IsDocumentApproved: true }),
      });
      toast.success(`${user.Users_NameSurname} belgeleriniz onaylandı.`);
      fetchUsers();
      // Görüntüleme modalı açıksa detailledUser'ı güncelle
      if (detailedUser && detailedUser.ID === user.ID) {
        setDetailedUser(prev => ({ ...prev, IsDocumentApproved: true }));
      }
    } catch (error) {
      toast.error("Belge onaylama sırasında bir hata oluştu.");
    } finally {
      setDocApproveLoading(null);
    }
  };

  // --- KULLANICI SİL ---
  const handleDeleteUser = async () => {
    if (!userToDelete) return;
    setIsDeleting(true);
    try {
      await fetch(`${BASE_URL}/Users(${userToDelete.ID})`, { method: "DELETE" });
      toast.success(`${userToDelete.Users_NameSurname} başarıyla silindi.`);
      setDeleteModal(false);
      setUserToDelete(null);
      fetchUsers();
    } catch (error) {
      toast.error("Silme sırasında bir hata oluştu.");
    } finally {
      setIsDeleting(false);
    }
  };

 const columns = useMemo(() => [
    { header: "ID", accessorKey: "ID", cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Ad Soyad",
      accessorKey: "Users_NameSurname",
      cell: (c) => (
        <div className="d-flex align-items-center">
          <div className="avatar-xs me-2">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary">{c.getValue()?.charAt(0)}</span>
          </div>
          {c.getValue()}
        </div>
      ),
    },
    { header: "E-posta", accessorKey: "Users_Email" },
    { header: "Rol", accessorKey: "Users_Type.Users_Type_Title", cell: (c) => <Badge color="info" pill>{c.getValue()}</Badge> },
    {
      header: "Durum",
      accessorKey: "IsActive",
      cell: (c) => <Badge color={c.getValue() ? "success" : "danger"}>{c.getValue() ? "Aktif" : "Pasif"}</Badge>
    },
    {
      header: "Belge Durumu",
      accessorKey: "IsDocument",
      cell: (c) => {
        const user = c.row.original;
        if (!user.IsDocument) return <Badge color="light" pill>Belge Yok</Badge>;
        if (user.Users_Type_ID !== 2 && user.Users_Type_ID !== 4) return <Badge color="warning" pill>Başvuru Bekliyor</Badge>;
        if (!user.IsDocumentApproved) return <Badge color="danger" pill>Belge Onayı Bekliyor</Badge>;
        return <Badge color="success" pill>Belgeler Onaylı</Badge>;
      }
    },
    {
      header: "Başvuru Tarihi",
      accessorKey: "Driver_Applied_At",
      cell: (c) => {
        const val = c.getValue();
        if (!val) return <span className="text-muted">—</span>;
        return (
          <span>
            {new Date(val).toLocaleDateString("tr-TR", {
              day: "2-digit", month: "2-digit", year: "numeric",
              hour: "2-digit", minute: "2-digit"
            })}
          </span>
        );
      }
    },
    {
      header: "Aksiyon",
      cell: (cellProps) => {
        const user = cellProps.row.original;
        const isDriverPending = user.IsDocument && user.Users_Type_ID !== 2 && user.Users_Type_ID !== 4;
        const isDocPending = user.IsDocument && (user.Users_Type_ID === 2 || user.Users_Type_ID === 4) && !user.IsDocumentApproved;
        const isApproving = approveLoading === user.ID;
        const isDocApproving = docApproveLoading === user.ID;
        return (
          <div className="d-flex gap-3 align-items-center">
            {isDriverPending && (
              <>
                <Button
                  color="link"
                  className="p-0 text-success"
                  id={`approve-${user.ID}`}
                  onClick={() => handleApproveDriver(user)}
                  disabled={isApproving}
                >
                  {isApproving
                    ? <Spinner size="sm" color="success" />
                    : <i className="mdi mdi-check-decagram font-size-18" />}
                </Button>
                <UncontrolledTooltip target={`approve-${user.ID}`}>Sürücü Başvurusunu Onayla (Tip 2 Yap)</UncontrolledTooltip>
              </>
            )}
            {isDocPending && (
              <>
                <Button
                  color="link"
                  className="p-0 text-warning"
                  id={`docapprove-${user.ID}`}
                  onClick={() => handleApproveDocuments(user)}
                  disabled={isDocApproving}
                >
                  {isDocApproving
                    ? <Spinner size="sm" color="warning" />
                    : <i className="mdi mdi-file-check-outline font-size-18" />}
                </Button>
                <UncontrolledTooltip target={`docapprove-${user.ID}`}>Yüklenen Belgeleri Onayla</UncontrolledTooltip>
              </>
            )}

            {/* KAPSAMLI DÜZENLE BUTONU */}
            <Button color="link" className="p-0 text-success" onClick={() => handleEditProfile(user)}>
              <i className="mdi mdi-pencil font-size-18" id={`edit-${user.ID}`} />
            </Button>

            <Button color="link" className="p-0 text-primary" onClick={() => handleViewProfile(user)}>
              <i className="mdi mdi-eye font-size-18" id={`view-${user.ID}`} />
            </Button>

            <Link to={`/kullanici-aktiviteleri/${user.ID}`} className="p-0 text-warning border-0 bg-transparent">
              <i className="mdi mdi-clipboard-list-outline font-size-18" id={`history-${user.ID}`} />
            </Link>

            <Button
              color="link"
              className="p-0 text-danger"
              id={`delete-${user.ID}`}
              onClick={() => { setUserToDelete(user); setDeleteModal(true); }}
            >
              <i className="mdi mdi-trash-can-outline font-size-18" />
            </Button>

            <UncontrolledTooltip target={`edit-${user.ID}`}>Tüm Bilgileri Düzenle</UncontrolledTooltip>
            <UncontrolledTooltip target={`view-${user.ID}`}>Kişisel Profili Gör</UncontrolledTooltip>
            <UncontrolledTooltip target={`history-${user.ID}`}>Sistem Aktiviteleri (İşler/Teklifler)</UncontrolledTooltip>
            <UncontrolledTooltip target={`delete-${user.ID}`}>Kullanıcıyı Sil</UncontrolledTooltip>
          </div>
        );
      }
    }
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Listesi" />
          <Card>
            <CardBody>
              {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
             <TableContainer
                columns={columns}
                data={users || []}
                isGlobalFilter={true}
                isPagination={true}
                customPageSize={users.length < 10 ? users.length : 10} 
                SearchPlaceholder="Kullanıcı ara..."
                tableClass="align-middle table-nowrap table-hover"
                theadClass="table-light"
                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                pagination="pagination pagination-rounded justify-content-end mb-2"
              />
              )}
            </CardBody>
          </Card>
        </Container>

        {/* ========================================================================= */}
        {/* --- MODAL: KAPSAMLI KULLANICI DÜZENLEME --- */}
        {/* ========================================================================= */}
        <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered size="lg">
          <ModalHeader toggle={() => setEditModal(false)} className="bg-light">
            <i className="mdi mdi-account-edit text-success me-2"></i> Kullanıcıyı Düzenle (#{selectedUser?.ID})
          </ModalHeader>
          <ModalBody className="p-0">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="success" /></div> : selectedUser && (
              <div className="bg-light-subtle pb-3">
                <Nav tabs className="nav-tabs-custom nav-justified bg-white pt-2">
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "1" })} onClick={() => setActiveEditTab("1")} style={{cursor:'pointer'}}>Genel Bilgiler</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "2" })} onClick={() => setActiveEditTab("2")} style={{cursor:'pointer'}}>Adres</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "3" })} onClick={() => setActiveEditTab("3")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "4" })} onClick={() => setActiveEditTab("4")} style={{cursor:'pointer'}}>Şirket & Finans</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeEditTab} className="p-4">
                  {/* DÜZENLE: GENEL BİLGİLER */}
                  <TabPane tabId="1">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ad Soyad</Label>
                            <Input type="text" value={selectedUser.Users_NameSurname} onChange={(e) => handleChange("Users_NameSurname", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">E-posta Adresi</Label>
                            <Input type="email" value={selectedUser.Users_Email} onChange={(e) => handleChange("Users_Email", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Telefon Numarası</Label>
                            <Input type="text" value={selectedUser.Users_PhoneNumber} onChange={(e) => handleChange("Users_PhoneNumber", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold d-block">Sistem Durumu</Label>
                            <div className="form-check form-switch form-switch-lg mb-3" dir="ltr">
                                <Input type="checkbox" className="form-check-input" checked={selectedUser.IsActive} onChange={(e) => handleChange("IsActive", e.target.checked)} />
                                <Label className="form-check-label fw-medium ms-2 mt-1">
                                {selectedUser.IsActive ? <span className="text-success">Aktif Kullanıcı</span> : <span className="text-danger">Hesap Dondurulmuş</span>}
                                </Label>
                            </div>
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: ADRES BİLGİLERİ */}
                  <TabPane tabId="2">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İl / Şehir</Label>
                            <Input type="text" placeholder="Örn: İstanbul" value={selectedUser.City} onChange={(e) => handleChange("City", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İlçe</Label>
                            <Input type="text" placeholder="Örn: Kadıköy" value={selectedUser.District} onChange={(e) => handleChange("District", e.target.value)} />
                        </Col>
                        <Col md={12}>
                            <Label className="fw-bold">Açık Adres</Label>
                            <Input type="textarea" rows="3" value={selectedUser.AddressText} onChange={(e) => handleChange("AddressText", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: EHLİYET BİLGİLERİ */}
                  <TabPane tabId="3">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Sınıfı</Label>
                            <Input type="text" placeholder="Örn: B, C, E" value={selectedUser.License_Class} onChange={(e) => handleChange("License_Class", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Numarası</Label>
                            <Input type="text" value={selectedUser.License_No} onChange={(e) => handleChange("License_No", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: ŞİRKET & FİNANS */}
                  <TabPane tabId="4">
                    <h6 className="text-primary border-bottom pb-2 mb-3">Şirket ve Vergi Bilgileri</h6>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">Şirket Adı / Ünvanı</Label>
                            <Input type="text" value={selectedUser.Company_Name} onChange={(e) => handleChange("Company_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Numarası / T.C. No</Label>
                            <Input type="text" value={selectedUser.Tax_No} onChange={(e) => handleChange("Tax_No", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Dairesi</Label>
                            <Input type="text" value={selectedUser.Tax_Office} onChange={(e) => handleChange("Tax_Office", e.target.value)} />
                        </Col>
                    </Row>

                    <h6 className="text-primary border-bottom pb-2 my-3">Banka Hesabı</h6>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Banka Adı</Label>
                            <Input type="text" placeholder="Örn: Garanti BBVA" value={selectedUser.Bank_Name} onChange={(e) => handleChange("Bank_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">IBAN Numarası</Label>
                            <Input type="text" placeholder="TR..." value={selectedUser.IBAN} onChange={(e) => handleChange("IBAN", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="bg-light">
            <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={isSaving}>İptal</Button>
            <Button color="success" onClick={handleEditSubmit} disabled={isSaving || isDetailsLoading}>
              {isSaving ? <Spinner size="sm" className="me-2" /> : <i className="mdi mdi-content-save me-1"></i>}
              Tüm Değişiklikleri Kaydet
            </Button>
          </ModalFooter>
        </Modal>

        {/* ========================================================================= */}
        {/* --- MODAL: PROFİL GÖR (SALT OKUNUR) --- */}
        {/* ========================================================================= */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered size="xl">
          <ModalHeader toggle={() => setViewModal(false)}>
            <i className="bx bx-user-circle me-2"></i> Kullanıcı Profili Detayı
          </ModalHeader>
          <ModalBody className="bg-light-subtle">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : detailedUser && (
              <>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 bg-white">
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "1" })} onClick={() => setActiveViewTab("1")} style={{cursor:'pointer'}}>Genel</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "2" })} onClick={() => setActiveViewTab("2")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "3" })} onClick={() => setActiveViewTab("3")} style={{cursor:'pointer'}}>Şirket & Banka</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "4" })} onClick={() => setActiveViewTab("4")} style={{cursor:'pointer'}}>Belgeler</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeViewTab}>
                  <TabPane tabId="1">
                    <Card><CardBody>
                      <Row>
                        <Col md={4} className="border-end">
                            <Label className="text-muted mb-0">Ad Soyad</Label><p className="fw-bold">{detailedUser.Users_NameSurname}</p>
                            <Label className="text-muted mb-0">E-posta</Label><p className="fw-bold">{detailedUser.Users_Email}</p>
                            <Label className="text-muted mb-0">Telefon</Label><p className="fw-bold">{detailedUser.Users_PhoneNumber || "---"}</p>
                            <Label className="text-muted mb-0">Belge Durumu</Label>
                            <p>
                              {!detailedUser.IsDocument
                                ? <Badge color="light">Belge Yok</Badge>
                                : (detailedUser.Users_Type_ID !== 2 && detailedUser.Users_Type_ID !== 4)
                                  ? <Badge color="warning">Başvuru Bekliyor</Badge>
                                  : !detailedUser.IsDocumentApproved
                                    ? <Badge color="danger">Belge Onayı Bekliyor</Badge>
                                    : <Badge color="success">Belgeler Onaylı</Badge>
                              }
                            </p>
                            {detailedUser.Driver_Applied_At && (
                              <>
                                <Label className="text-muted mb-0">Başvuru Tarihi</Label>
                                <p className="fw-bold">
                                  {new Date(detailedUser.Driver_Applied_At).toLocaleDateString("tr-TR", {
                                    day: "2-digit", month: "2-digit", year: "numeric",
                                    hour: "2-digit", minute: "2-digit"
                                  })}
                                </p>
                              </>
                            )}
                        </Col>
                        <Col md={8}>
                            <Label className="text-muted mb-0">Adres</Label>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_AdressText || "Bilgi Yok"}</p>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_City} / {detailedUser.Users_Address?.[0]?.Users_Address_Dist}</p>
                        </Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card><CardBody>
                      <Row>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Sınıfı</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Class || "---"}</p></Col>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Numarası</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Number || "---"}</p></Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="3">
                    <Card><CardBody>
                      <h6 className="text-primary border-bottom pb-2">Şirket Bilgileri</h6>
                      <p><strong>Firma:</strong> {detailedUser.Users_Company?.[0]?.Users_Company_Name || "Kayıtlı Şirket Yok"}</p>
                      <p><strong>Vergi No:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.KdvNumber || "---"}</p>
                      <p><strong>Vergi Dairesi:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.VergiDairesi || "---"}</p>
                      <h6 className="text-primary border-bottom pb-2 mt-4">Banka Bilgileri</h6>
                      <p><strong>IBAN:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_Iban || "---"}</p>
                      <p><strong>Banka:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_BankName || "---"}</p>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="4">
                    {/* Belge onay durumu banner */}
                    {detailedUser.IsDocument ? (
                      detailedUser.IsDocumentApproved ? (
                        <div className="alert alert-success d-flex align-items-center gap-2 mb-3">
                          <i className="mdi mdi-check-circle-outline font-size-18"></i>
                          <span className="fw-bold">Belgeler onaylandı.</span>
                        </div>
                      ) : (
                        <div className="alert alert-warning d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center gap-2">
                            <i className="mdi mdi-clock-alert-outline font-size-18"></i>
                            <span className="fw-bold">Belgeler inceleme bekliyor.</span>
                          </div>
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => handleApproveDocuments(detailedUser)}
                            disabled={docApproveLoading === detailedUser.ID}
                          >
                            {docApproveLoading === detailedUser.ID
                              ? <Spinner size="sm" />
                              : <><i className="mdi mdi-file-check-outline me-1"></i>Belgeleri Onayla</>
                            }
                          </Button>
                        </div>
                      )
                    ) : (
                      <div className="alert alert-secondary mb-3">
                        <i className="mdi mdi-information-outline me-1"></i>
                        Bu kullanıcı henüz belge yüklemedi.
                      </div>
                    )}

                    <Row>
                        {[
                            { n: "Kimlik Fotoğrafı", u: detailedUser.Users_Document?.[0]?.Identity_Url },
                            { n: "Ehliyet", u: detailedUser.Users_Document?.[0]?.License_Url },
                            { n: "Sabıka Kaydı", u: detailedUser.Users_Document?.[0]?.Criminalrecord_Url },
                            { n: "Vergi Levhası", u: detailedUser.Users_Document?.[0]?.Taxplate_Url },
                            { n: "Çekici Sertifikası", u: detailedUser.Users_Document?.[0]?.TowingCertificate },
                        ].map((doc, i) => (
                            <Col md={4} key={i} className="mb-3">
                                <Card className="text-center border shadow-none h-100">
                                    <CardBody className="d-flex flex-column align-items-center justify-content-between gap-2">
                                        <i className={`mdi ${doc.u ? "mdi-file-check-outline text-success" : "mdi-file-outline text-muted"} display-5`}></i>
                                        <p className="mb-1 fw-semibold">{doc.n}</p>
                                        {doc.u
                                          ? <a href={doc.u} target="_blank" rel="noreferrer" className="btn btn-sm btn-soft-primary w-100">
                                              <i className="mdi mdi-eye-outline me-1"></i>Görüntüle
                                            </a>
                                          : <Badge color="light" className="w-100 py-2">Yüklenmemiş</Badge>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
        {/* ========================================================================= */}
        {/* --- MODAL: KULLANICI SİL ONAY --- */}
        {/* ========================================================================= */}
        <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered size="sm">
          <ModalHeader toggle={() => setDeleteModal(false)} className="bg-danger text-white">
            <i className="mdi mdi-alert-outline me-2"></i> Kullanıcıyı Sil
          </ModalHeader>
          <ModalBody className="text-center py-4">
            <p className="mb-1">
              <strong>{userToDelete?.Users_NameSurname}</strong> adlı kullanıcıyı silmek istediğinize emin misiniz?
            </p>
            <p className="text-muted small">Bu işlem geri alınamaz.</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" outline onClick={() => setDeleteModal(false)} disabled={isDeleting}>İptal</Button>
            <Button color="danger" onClick={handleDeleteUser} disabled={isDeleting}>
              {isDeleting ? <Spinner size="sm" className="me-2" /> : <i className="mdi mdi-trash-can-outline me-1"></i>}
              Evet, Sil
            </Button>
          </ModalFooter>
        </Modal>

      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default KullaniciListesi;